<template>
	<div :class="{ row: display === 'row', errormessage: error && error != '' }">
		<label v-if="label" :for="identifier" :style="{ width: labelWidth + 'px' }">{{label}}</label>

		<multiselect :value="foundValue"
						:options="options"
						@input="update"
						:multiple="multiple"
						:hide-selected="true"
						:close-on-select="true"
						:clear-on-select="true"
						:label="optionLabel"
						:track-by="optionTrackBy"
						placeholder="Pick a value"
						:class="{ multiple: multiple, single: !multiple }">
		</multiselect>
		
		<div class="error">
			<span v-if="error" class="errormessage">{{error}}</span>
		</div>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'

	export default {
		name: 'MultiSelectInput',
		components: { Multiselect },
		data() {
			return {

			}
		},
		props: ['label', 'value', 'identifier', 'display', 'labelWidth', 'type', 'attrs', 'options', 'optionLabel', 'optionTrackBy', 'multiple', 'error'],
		computed: {
			foundValue: function () {
				var that = this;

				if (!this.options || this.options.length === 0) return null;
				if (this.multiple !== false) return this.value;

				return this.options.filter(function (el) { return el[that.optionTrackBy] === that.value })[0];
			}
		},
		methods: {

			update: function (event) {

				if (this.multiple) {
					this.$emit('input', event);
					this.$emit('valueChanged', event);
				}
				else {
					this.$emit('input', event[this.optionTrackBy]);
					this.$emit('valueChanged', event[this.optionTrackBy]);
				}
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
	$lightgrey: #afafaf;

	div.row {
		display: flex;
	}

	label {
		margin-top: 8px;
		margin-bottom: 5px;
		display: block;
	}

	.multiselect {
		width: 100%;
	}

	input::-webkit-input-placeholder {
		color: $lightgrey;
	}

	input::-moz-placeholder {
		color: $lightgrey;
	}

	input:-ms-input-placeholder {
		color: $lightgrey;
	}

	input:-moz-placeholder {
		color: $lightgrey;
	}

	.error {
		position:absolute;
		right:0;
		padding-top:3px;
		font-size:0.8em;
		color:#d43131;
		margin-top: 9px;
		margin-right: 40px;
	}

	.error span {
		width: 100%;
		text-align: right;
	}

	.errormessage .multiselect {
		border: 1px solid #d43131;
	}
</style>
